<template><div><h1 id="op-kontoauszug" tabindex="-1"><a class="header-anchor" href="#op-kontoauszug"><span>OP-Kontoauszug</span></a></h1>
<p>OP-Kontoauszug — Liste der Buchungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste aus allen Buchungen, die den gewählten Parametern (Personen-ID, Datum) entsprechen. Die Liste wird nach Personen-ID und anschliessend nach Datum sortiert. Zusätzlich kann nach einem bestimmten Personenmerkmal eingegrenzt werden. Die Auswertung kann auch nur offene Buchungen berücksichtigen. Es ist möglich, Adresszeilen (in Kurzform) für jede Personen-ID im Protokoll anzuzeigen.</p>
<p>Pfad: <code v-pre>Buchhaltung → Auswertungen → OP-Kontoauszüge → OP-Kontoauszug</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von Personen-ID/bis</dt>
<dd>Einschränkung auf Adresse/Adressbereich</dd>
<dt>von Datum/bis</dt>
<dd>Einschränkung auf Datum/Datumsbereich</dd>
<dt>Adresse in Kurzform anzeigen</dt>
<dd>Bei &quot;ja&quot; werden Adressdaten auf die Liste ausgegeben</dd>
<dt>ausgeglichene Buchungen ignorieren</dt>
<dd>Bei &quot;ja&quot; werden ausgeglichene Buchungen nicht auf die Liste ausgegeben</dd>
<dt>Buchungen mit Ausgleich nach dem bis-Datum ignorieren</dt>
<dd>Bei &quot;ja&quot; werden Buchungen, die eine Ausgleichsbuchung nach dem bis-Datum aufweisen, nicht auf die Liste ausgegeben</dd>
<dt>nur mit Merkmal</dt>
<dd>Es werden nur Buchungen ausgelistet, die innerhalb des angegebenen Personen-ID-Bereichs dieses Merkmal besitzen.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Info-Felder:</td>
<td>Rekapitulation der eingegebenen Parameter</td>
</tr>
<tr>
<td></td>
<td>wenn Adresse anzeigen = ja: Kurzform der Adresse</td>
</tr>
<tr>
<td>Spalten:</td>
<td>Spalten:</td>
</tr>
<tr>
<td>- Adresse:</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>- Datum :</td>
<td>Belegdatum</td>
</tr>
<tr>
<td>- FaktNr :</td>
<td>Fakturanummer, oder:- wenn [Auswertungsdatum] &lt; [von Datum]: 'vorher'- wenn [Auswertungsdatum] &gt; [bis Datum]: ' nachher'- wenn Buchungstyp = G oder GS: 'Guthab.'</td>
</tr>
<tr>
<td>- T :</td>
<td>Buchungstyp</td>
</tr>
<tr>
<td>- Soll :</td>
<td>Betrag im Soll</td>
</tr>
<tr>
<td>- Haben:</td>
<td>Betrag im Haben</td>
</tr>
<tr>
<td>- Pos.Saldo:</td>
<td>Saldo für jeden OP</td>
</tr>
<tr>
<td>- Lfd.Saldo:</td>
<td>kumulativer, laufender Saldo aus allen OP pro Belegdatum</td>
</tr>
<tr>
<td>Zeilen:</td>
<td>Zeilen:</td>
</tr>
<tr>
<td>Total:</td>
<td>Summe pro Adresse von [Soll], [Haben], [Pos.Saldo], [Lfd.Saldo]</td>
</tr>
</tbody>
</table>
<p>Outputbeispiel ohne Adressdetails</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Stamm: Manuelle Buchungen                   19.02.1999 09:13:15 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                                OP-Kontoauszug</span>
<span class="line">                 von Personen-ID:    479,426 bis:    479,426</span>
<span class="line">                 von Datum.......:            bis:</span>
<span class="line"></span>
<span class="line">                 Adresse anzeigen: nein</span>
<span class="line"></span>
<span class="line">                 nur offene Buch.: nein</span>
<span class="line">                 'nacher' aussch.: nein</span>
<span class="line">                 nur mit Merkmal.:</span>
<span class="line"></span>
<span class="line"> Adresse Datum     FaktNr T          Soll         Haben   Pos.Saldo   Lfd.Saldo</span>
<span class="line">-------- -------- ------- --------------- ------------- ----------- -----------</span>
<span class="line">  479426 18.02.99 2336209 A         24.90                    -24.90</span>
<span class="line">       .        .       . AS                       4.00        4.00      -20.90</span>
<span class="line">--------                    ------------- ------------- ----------- -----------</span>
<span class="line">  479426                            24.90          4.00      -20.90      -20.90 TOTAL</span>
<span class="line"></span>
<span class="line">                            ------------- ------------- ----------- -----------</span>
<span class="line">                                    24.90          4.00      -20.90      -20.90 TOTAL</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Outputbeispiel mit Adressdetails</p>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line"></span>
<span class="line">Stamm: Manuelle Buchungen                   19.02.1999 09:20:56 leh  Seite     0</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">                                OP-Kontoauszug</span>
<span class="line">                 von Personen-ID:    479,426 bis:    479,426</span>
<span class="line">                 von Datum.......:            bis:</span>
<span class="line"></span>
<span class="line">                 Adresse anzeigen: ja</span>
<span class="line"></span>
<span class="line">                 nur offene Buch.: nein</span>
<span class="line">                 'nacher' aussch.: nein</span>
<span class="line">                 nur mit Merkmal.:</span>
<span class="line"></span>
<span class="line">                              Adresse (Kurzform)</span>
<span class="line"> Nr: 479426  Hansueli Muster                                    Vw.: 1</span>
<span class="line"> Flüelastrasse 11                           Status: --K-   --   Tel:  4014144</span>
<span class="line"> 8048 Zürich                                Geb.J.:   61        Fax:</span>
<span class="line"></span>
<span class="line"> Adresse Datum     FaktNr T          Soll         Haben   Pos.Saldo   Lfd.Saldo</span>
<span class="line">-------- -------- ------- --------------- ------------- ----------- -----------</span>
<span class="line">  479426 18.02.99 2336209 A         24.90                    -24.90</span>
<span class="line">       .        .       . AS                       4.00        4.00      -20.90</span>
<span class="line">--------                    ------------- ------------- ----------- -----------</span>
<span class="line">  479426                            24.90          4.00      -20.90      -20.90 TOTAL</span>
<span class="line"></span>
<span class="line">                            ------------- ------------- ----------- -----------</span>
<span class="line">                                    24.90          4.00      -20.90      -20.90 TOTAL</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Lesebeispiel: Der Kunde 479426 hat uns einen Auftrag erteilt am 18.2.99 im Wert von Fr. 24.90. Mit gleichem Datum wurde ein Retourenauftrag (AS) gebucht von Fr. 4.--. Das Debitorenkonto weist einen offenen Saldo von Fr. 20.90 aus.</p>
</div></template>


